module.exports = __webpack_public_path__ + "img/ic_list_select.76d61ce1.svg";